import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different regimen action types
*/
let initialstate = {
  isLoading: false,
  assignedRegs: [],
  filters: {},
  regimens: [],
}
export default function regimen_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.REG_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.REG_SET_ASSIGNED:
      return { ...state, assignedRegs: action.regimens }
    case ActionType.REG_SET_FILTERS:
      return { ...state, filters: action.filters }
    case ActionType.REG_SET_REGS:
      return { ...state, regimens: action.regimens, filters: action.filters }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
